module.exports = __webpack_public_path__ + "static/img/Touchngo.7a8a4c1c.jpg";